import { deriveBetTicketGroups } from '@core/jackpot/jackpotView'
import { JACKPOT_MESSAGES, JACKPOT_TEXTS } from '@constants/jackpotConstants'

// One bet's ticket ids, expanded from its range. Pure render — the
// contributions list + selected betId travel via navigation params (see
// useJackpotNavigation), no fetch here (mirrors defenderV2 passing the same
// already-fetched array down instead of refetching).
const JackpotBetTicketsScreen = ({ contributions, betId }) => {
  const { groups, totalTickets } = deriveBetTicketGroups(contributions, betId)

  if (!groups.length) {
    return (
      <div className="standard-normal-jackpot-tickets-outer-container">
        <div className="standard-normal-jackpot-tickets-empty-message">
          {JACKPOT_MESSAGES.NO_BET_TICKETS}
        </div>
      </div>
    )
  }

  return (
    <div className="standard-normal-jackpot-tickets-outer-container">
      <div className="standard-normal-jackpot-tickets-info-container">
        <span>{JACKPOT_TEXTS.TOTAL_TICKETS_PREFIX}&nbsp;</span>
        <span>{totalTickets}</span>
      </div>
      <div className="standard-normal-jackpot-tickets-groups-container no-scrollbar">
        {groups.map((group, index) => (
          <div
            key={index}
            className={`standard-normal-jackpot-bet-ticket-group ${group.isSelectedBet ? 'standard-normal-jackpot-bet-ticket-group-selected' : ''}`}
          >
            <div className="standard-normal-jackpot-bet-ticket-group-info">
              <span>Bet ID: {group.betId}</span>
              <span>
                Date : {group.date} {group.time}
              </span>
            </div>
            <div className="standard-normal-jackpot-ticket-ids-container">
              {group.ticketIds.map((id) => (
                <div key={id} className="standard-normal-jackpot-ticket-id">
                  {id}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default JackpotBetTicketsScreen
